class ColorChangeComponent extends HTMLElement {
  constructor() {
    super();
    const swatchContainer = this.querySelector("fieldset");
    const hidecountbtn = this.querySelector(".over-swatch-btn");
    var countnum = hidecountbtn.querySelector(".more-swatch");
    const swathitem = this.querySelectorAll(".s-item");
    const swatchinput = this.querySelectorAll(".swatch-input__input");
    const swatchbtn = this.querySelectorAll(".swatch");
    var backtoleft = this.querySelector(".backtoleft");
    swatchinput.forEach((swinput) => {
      swinput.addEventListener("click", this.onClicktoCoverImage2.bind(this));
    });
    swatchbtn.forEach((swatch) => {
      swatch.addEventListener("click", this.onClicktoCoverImage.bind(this));
      swatch.addEventListener(
        "mouseenter",
        this.onHovertoCoverImage.bind(this)
      );
      swatch.addEventListener("keydown", this.onkeydownSwatch.bind(this));
    });
    hidecountbtn.addEventListener("click", this.onShowMoreColor.bind(this));
    if (backtoleft)
      backtoleft.addEventListener("click", this.onshowOriginColor.bind(this));

    function debounce(func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    }

    const resizeObserver = new ResizeObserver(
      debounce(() => {
        setTimeout(() => {
          const containerWidth = swatchContainer.clientWidth;
          if (containerWidth != 0) {
            this.init(swatchContainer, swathitem, hidecountbtn, countnum);
          } else {
            setTimeout(() => {
              this.init(swatchContainer, swathitem, hidecountbtn, countnum);
            }, 200);
          }
        }, 200);
      }, 200)
    );

    resizeObserver.observe(swatchContainer);
  }

  init(swatchContainer, swathitem, hidecountbtn, countnum) {
    const containerWidth = swatchContainer.clientWidth;
    const swatchWidth = Array.from(swathitem).reduce((total, swatch) => {
      return total + swatch.offsetWidth + 4;
    }, 0);

    if (swatchWidth > containerWidth) {
      let hidedefaultshownum = this.calculateSwatches(
        containerWidth,
        swathitem[0].offsetWidth + 4
      );
      let showcolorcount = swathitem.length - hidedefaultshownum;
      // console.log("hidecolorcount:"+  showcolorcount);
      // console.log("hidedefaultshownum:"+  hidedefaultshownum);
      // console.log("lenght:"+  swathitem.length);
      swatchContainer.style.width = containerWidth;
      hidecountbtn.classList.remove("hidden");
      countnum.textContent = "+" + showcolorcount;
      countnum.setAttribute("more-swatch-count", hidedefaultshownum);
      countnum.setAttribute("hide-swatch-count", showcolorcount);

      swathitem.forEach((item, index) => {
        if (index >= hidedefaultshownum) {
          item.classList.add("d-none");
        }
      });
    }
  }

  onshowOriginColor(event) {
    const elElement = event.currentTarget;
    const elPrent = elElement.closest(".item-swatch");
    let hidecountbtn = elPrent.querySelector(".over-swatch-btn");
    elElement.classList.add("d-none");
    hidecountbtn.classList.remove("d-none");
    elPrent.style.left = `0`;
    var hideitem = elPrent.querySelectorAll(".s-item.d-block");
    hideitem.forEach((item) => {
      item.classList.remove("d-block");
    });
  }
  calculateSwatches(containerWidth, swatchWidth) {
    let containerUseWidth = containerWidth - swatchWidth;
    const count = Math.floor(containerUseWidth / swatchWidth); // 计算能放多少个色块
    return count;
  }

  onShowMoreColor(event) {
    const elElement = event.currentTarget;
    const elPrent = elElement.closest(".item-swatch");
    const index = elElement
      .querySelector(".more-swatch")
      .getAttribute("more-swatch-count");
    const elPrent_toLeft = Number(index * 34);
    let backleftbtn = elPrent.querySelector(".backtoleft");
    if (backleftbtn) var newLi = backleftbtn;
    else {
      var newLi = document.createElement("li");
      newLi.className = "backtoleft";
      newLi.innerHTML = `<label>
                <svg aria-hidden="true" role="img" aria-labelledby="backleft-${index}" tabindex="0" width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg" style="fill: none;">
                    <title id="backleft-${index}">button to view more</title>
                    <path d="M0.999541 1.40417L5.11719 5.52182L0.99954 9.63947" stroke="#B4B4B4" stroke-width="1.23529"></path>
                </svg>
                <span class="sr-only">Back to view left colors</span>
                </label>
            `;
    }
    const targetLI = elPrent.querySelector(`li:nth-child(${index})`);

    targetLI.parentNode.insertBefore(newLi, targetLI.nextSibling);

    let hideitem = elElement
      .closest(".item-swatch")
      .querySelectorAll(".s-item.d-none");
    hideitem.forEach((item) => {
      item.classList.add("d-block");
    });
    elElement.classList.add("d-none");
    newLi.classList.remove("d-none");
    elPrent.style.left = `-${elPrent_toLeft}px`;

    newLi.addEventListener("click", (event) => {
      this.onshowOriginColor(event);
    });
  }
  onClicktoCoverImage2(event) {
    const elElement = event.currentTarget;
    const labelElement = elElement.nextElementSibling;
    if (labelElement) {
      const swatchElement = labelElement.querySelector(".swatch");
      swatchElement.click();
    }
  }
  onClicktoCoverImage(event) {
    const elElement = event.currentTarget;
    const imgSrc = elElement.getAttribute("data-img");
    const parentWrapper = elElement.closest(".card-wrapper");
    const target_img = parentWrapper.querySelector(".card__media img:nth-child(1)");
    const target_img_src = target_img.getAttribute("src");

    elElement.setAttribute("tabindex", 0);
    if (target_img_src != imgSrc) {
      target_img.setAttribute("src", imgSrc);
      target_img.setAttribute("srcset", imgSrc);
      console.log("Updated img src to:", imgSrc);
    } else {
      console.log("No img element found.");
    }

    const parentLi = elElement.closest(".item-swatch");
    const siblings = parentLi.querySelectorAll(".swatch");
    siblings.forEach((sibling) => {
      if (sibling !== elElement) {
        sibling.setAttribute("tabindex", "-1");
      }
    });
  }
  onHovertoCoverImage(event) {
    const elElement = event.currentTarget;

    if (event.type == "mouseenter") {
      elElement.click();
    }
  }

  onkeydownSwatch(event) {
    const elElement = event.currentTarget;
    const index = parseInt(elElement.getAttribute("data-valueindex"));
    const totalSize = parseInt(
      elElement.closest(".item-swatch").getAttribute("data-count")
    );
    let nextIndex = index + 1;
    let prevIndex = index - 1;

    // 循环处理
    if (nextIndex > totalSize) {
      nextIndex = 1;
    }
    if (prevIndex <= 0) {
      prevIndex = totalSize;
    }

    // 处理键盘事件
    if (event.key === "Enter" || event.key == " ") {
      this.click();
    }
    if (event.key === "ArrowRight" || event.key === "ArrowDown") {
      const nextLabel = elElement
        .closest(".item-swatch")
        .querySelector(`.swatch[data-valueindex='${nextIndex}']`);
      if (nextLabel) {
        nextLabel.focus();
        nextLabel.click();
        nextLabel.addEventListener(
          "click",
          this.onClicktoCoverImage.bind(this)
        );

        // nextLabel.dispatchEvent(new MouseEvent('mouseover')); // 触发 mouseover 事件
      }
    }
    if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
      const prevLabel = elElement
        .closest(".item-swatch")
        .querySelector(`.swatch[data-valueindex='${prevIndex}']`);
      if (prevLabel) {
        prevLabel.focus();
        prevLabel.click();
        // prevLabel.dispatchEvent(new MouseEvent('mouseover')); // 触发 mouseover 事件
        prevLabel.addEventListener(
          "click",
          this.onClicktoCoverImage.bind(this)
        );
      }
    }
  }
}
customElements.define("color-change-component", ColorChangeComponent);
